var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-empty',{attrs:{"description":"请在电脑上打开"}})
}
var staticRenderFns = []

export { render, staticRenderFns }